export default __webpack_public_path__ + "static/media/img-adult.277cbbd7.svg";